export enum DigitalShowroomApi {
  VetusiteAuth0PasswordlessStart = 'https://vetsuite.us.auth0.com/passwordless/start',
  VetsuiteAuth0PasswordlessToken = 'https://vetsuite.us.auth0.com/oauth/token',
  // VetsuiteGetContact = 'https://covetrus-fallback-development.azurewebsites.net/getContact',
  CovetrusRequestForQuote = '/covetrus/rfq'
}
